export { useResizeHandle } from './hooks/useResizeHandle';
export { EVENTS } from './types';

export type { ResizeHandleUpdateEventData } from './types';
export type { UseResizeHandleParams } from './hooks/useResizeHandle';
